// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"yl","summaryPar":"zl","ratingCategories":"Al","reviewerInfo":"Bl","reviewTypes":"Cl","expanded":"Dl"};